import React from 'react';
import { Link } from 'react-router-dom';
import SectionHeading from './SectionHeading';

// Homepage teaser mirrors the real admin category taxonomy (see
// freshnhomely-backend/src/utils/categorySlugs.js) so it never drifts from
// what customers actually find on /categories — each tile links straight to
// its live category page rather than just anchoring the homepage section.
// Uses the same product photography as CategoryCard.jsx's /categories grid
// rather than icon tiles, so the homepage teaser and the real listing page
// present the same visual identity for each category.
const categories = [
  { key: 'chicken', image: '/chicken1.jpg', title: 'Chicken', description: 'Fresh cuts, cleaned daily' },
  { key: 'mutton-goat-lamb', image: '/mutton.jpg', title: 'Mutton', description: 'Premium cuts, freshly prepared' },
  { key: 'seafood', image: '/fish.jpg', title: 'Fish & Seafood', description: 'Ocean-fresh, unmatched quality' },
  { key: 'fresh-fruits-and-vegetables', image: '/fruits.jpg', title: 'Vegetables', description: 'Naturally fresh, handpicked' },
  { key: 'eggs', image: '/eggs.jpg', title: 'Eggs', description: 'Farm-fresh, quality checked' },
  { key: 'groceries', image: '/grocery.jpg', title: 'Groceries', description: 'Daily essentials, delivered fast' },
];

const Categories = () => (
  <section id="categories" className="py-24 bg-gradient-to-b from-white via-emerald-50/50 to-white relative overflow-hidden">
    <div
      className="absolute top-1/2 left-1/2 w-[36rem] h-[36rem] -translate-x-1/2 -translate-y-1/2 bg-emerald-100/30 rounded-full blur-3xl pointer-events-none"
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <SectionHeading
        eyebrow="Curated Freshness"
        title="Shop by Category"
        description="Explore our wide range of handpicked fresh products curated for your healthy lifestyle."
      />

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-6">
        {categories.map((category) => (
          <Link
            key={category.key}
            to={`/categories/${category.key}`}
            className="card-hover group relative flex flex-col bg-white rounded-3xl border border-emerald-100/70 shadow-soft overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-700 focus-visible:ring-offset-2"
          >
            <div className="relative h-28 sm:h-32 overflow-hidden">
              <img
                src={category.image}
                alt={category.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent" aria-hidden="true" />
              <div
                className="absolute inset-x-0 bottom-0 h-1 bg-gradient-primary scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300"
                aria-hidden="true"
              />
            </div>
            <div className="px-4 py-4 text-center">
              <h3 className="font-bold text-emerald-950 text-sm sm:text-base leading-tight mb-1">
                {category.title}
              </h3>
              <p className="text-xs text-ink-secondary leading-snug">{category.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default Categories;
